<mat-form-field [ngClass]='{"w-100":maxWidthNeeded}'>
    <mat-label for='waterSourceInput' *ngIf='labelNeeded'>Water Source</mat-label>
    <!--                      <p *ngIf='!selectingWaterSource' (click)='selectWaterSource()'-->
    <!--                         role='button'>{{selectedItem.location.waterSource || selectedItem.waterSource}}</p>-->
    <mat-autocomplete id='waterSourceAutocomplete'
                      #autoWater='matAutocomplete'
                      (optionSelected)='handleWaterSourceChange($event, selectedItem.calculationResult?.testId, selectedItem.location?.place_id)'
                      [displayWith]='displayFnWaterSource.bind(this)'
                      [hidden]='lastTypedSourceValue === undefined'>


        <small class='font-weight-bold p-2'
               [hidden]='filteredUserSavedWaterSources && filteredUserSavedWaterSources.length === 0'>Saved Sources:</small>
        <div class='selection-div row p-1'
             *ngFor='let waterSource of filteredUserSavedWaterSources'>
            <mat-option class='col-lg-10 col-8' [value]='waterSource'>
                {{waterSource.name}}
            </mat-option>
            <button class='btn btn-outline-danger mx-auto' (mousedown)='deleteWaterSource($event)'
                    [value]='waterSource.source_id'>
                <i class='fas fa-trash-alt'></i>

            </button>
        </div>
        <mat-option
                [hidden]='lastTypedSourceValue === undefined ||
                          this.lastTypedSourceValue === "" ||
                          this.lastTypedSourceValue === this.selectedItem.location?.waterSource'
                class='col-12'
                [value]='{"name":this.lastTypedSourceValue, "place_id":"", "source_id":""}'>
            <div>
                <mdb-icon fas icon='plus' class='blue-text mr-1'></mdb-icon>
                {{"Add new: \"" + this.lastTypedSourceValue + "\""}}
            </div>
        </mat-option>
    </mat-autocomplete>
    <div>

        <!--suppress AngularUndefinedBinding -->
        <input type='text'
               aria-label='Water Source'
               matInput
               id='waterSourceInput'
               #inputField
               #waterSourceTrigger='matAutocompleteTrigger'
               [ngStyle]="{'min-width': widthNeeded ? '20em' : null }"

               (focus)='this.showWaterSourceClear = true'
               [ngModel]='selectedItem.location ? selectedItem.location.waterSource ? selectedItem.location.waterSource : null : null'
               [matAutocomplete]='autoWater' name='txtSourcesSelect'
               (ngModelChange)='filterUserWaterSources($event)'
               (keyup.enter)='handleWaterSourceChangeManual($event,selectedItem.calculationResult?.testId,this.selectedItem.location?.place_id)'
               [value]='this.lastTypedSourceValue'
               class='d-inline col-10 col-lg-11'>
        <button class='btn clear-button' type='button' mat-button *ngIf='this.lastTypedSourceValue && clearNeeded'
                matSuffix
                mat-icon-button
                [hidden]='!showWaterSourceClear'
                aria-label='Clear'
                (click)='this.clearWaterSourceInput()'>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</mat-form-field>
